<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">アイコン登録</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <h1>アイコン情報</h1>
          <div class="column-list">
            <label class="list-input-title">アイコンコード</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1506Model.iconCode" [style.width.rem]="3" [disabled]="!kymw1506Model.iconCodeEntry" class="text-label-required"
                [maxLength]="3" [restrict]="'[0-9]'" [halfOnly]="true" #inputText plessInputTextSub>
              <app-checkbox-label id="chk_IconCodeEntry" #chk_IconCodeEntry [subid]="'chk_IconCodeEntry'"
                label="コード指定" [(ngModel)]="kymw1506Model.iconCodeEntry" (change)="eventIconCodeEntry_CLICKHandler()"
                autofocus="true" [tabindex]="0" [style.margin-top.px]="4">
              </app-checkbox-label>
            </div>
            <label class="list-input-title">アイコン名</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1506Model.iconName" [style.width.rem]="22" class="text-label-required" [maxLength]="20"
                plessInputTextSub [restrict]="'[ -￮]'" [fullOnly]="true">
            </div>
            <label class="list-input-title">グループ</label>
            <div class="list-input-content">
              <app-versatile-combo-box [listSource]="kymw1506Model.markGroupList" valueField="MarkGroupCode" labelField="Caption" [disabled]="false"
                [required]="true" [width]="200" [height]="20" [tabindex]="0" [visible]="true" [autofocus]="false" [blank]="true"
                forcedEnabledMode="true" [(ngModel)]="kymw1506Model.iconGroup" (change)="eventIconGroup_CHANGEHandler()">
              </app-versatile-combo-box>
            </div>
            <label class="list-input-title">アイコン区分</label>
            <div class="list-input-content">
              <app-code-combo-box id="cmb_IconDiv" #cmb_IconDiv [subid]="'cmb_IconDiv'"
                [codeDiv]="'ctp050'" [forcedEnabledMode]="'true'" [style.width.px]="200"
                [tabindex]="0" [required]="true" [(ngModel)]="kymw1506Model.iconDiv">
              </app-code-combo-box>
            </div>
            <label class="list-input-title">配置区分</label>
            <div class="list-input-content">
              <app-code-combo-box id="cmb_ArrangeDiv" #cmb_IconDiv [subid]="'cmb_ArrangeDiv'"
                [codeDiv]="'ctp051'" [forcedEnabledMode]="'true'" [style.width.px]="200"
                [tabindex]="0" [required]="true" [(ngModel)]="kymw1506Model.arrangeDiv">
              </app-code-combo-box>
            </div>
            <label class="list-input-title">アイコン説明</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1506Model.iconExplain" [style.width.rem]="22" class="text-label-required" [maxLength]="20"
                plessInputTextSub [restrict]="'[ -￮]'" [fullOnly]="true">
            </div>
            <label class="list-input-title">出力区分</label>
            <div class="list-input-content">
              <app-checkbox-label #chb_Category label="商品マスタ" id="chb_Category" [(ngModel)]="kymw1506Model.category"
                [subid]="'chb_Category'" [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
              <app-checkbox-label #chb_Weekly label="ウィークリー" id="chb_Weekly" [(ngModel)]="kymw1506Model.weekly"
                [subid]="'chb_Weekly'" [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
              <app-checkbox-label #chb_Daily label="デイリー" id="chb_Daily" [(ngModel)]="kymw1506Model.daily"
                [subid]="'chb_Daily'" [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
              <app-checkbox-label #chb_Logistics label="見切り品" id="chb_Logistics" [(ngModel)]="kymw1506Model.logistics"
                [subid]="'chb_Logistics'" [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
              <app-checkbox-label #Order label="注文確認画面表示対象フラグ" id="chb_Order" [(ngModel)]="kymw1506Model.order"
                [subid]="'chb_Order'" [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
            </div>
          </div>
        </div>

        <div>
          <h1>ファイル情報</h1>
          <div class="element-column">
            <div class="column-list">
              <label class="list-input-title">使用開始受注コード</label>
              <div class="list-input-content">
                <app-order-code-text-input id="txt_StartOrderCode" #txt_StartOrderCode [subid]="'txt_StartOrderCode'"
                  [catalogIDField]="lbl_StartDelivCatalogId" [disabled]="!kymw1506Model.startOrderCodeEnabled"
                  [(ngModel)]="kymw1506Model.startOrderCode" [tabindex]="0" [required]="true" class="deliv-catalog">
                </app-order-code-text-input>
                <app-checkbox-label id="chk_NotDesignateStart" #chk_NotDesignateStart [subid]="'chk_NotDesignateStart'"
                  label="指定なし" [(ngModel)]="kymw1506Model.notDesignateStart" (change)="eventNotDesignateStart_CLICKHandler()"
                  autofocus="true" [tabindex]="0"  [style.margin-top.px]="4">
                </app-checkbox-label>
              </div>
              <label class="list-input-title">使用開始配達企画回(翌週)</label>
              <div class="list-input-content">
                <input type="text" class="deliv-catalog" id="lbl_StartDelivCatalogId" #lbl_StartDelivCatalogId readonly/>
              </div>
              <label class="list-input-title">使用終了受注コード</label>
              <div class="list-input-content">
                <app-order-code-text-input id="txt_EndOrderCode" #txt_EndOrderCode [subid]="'txt_EndOrderCode'"
                  [catalogIDField]="lbl_EndDelivCatalogId" [disabled]="!kymw1506Model.endOrderCodeEnabled"
                  [(ngModel)]="kymw1506Model.endOrderCode" [tabindex]="0" [required]="true">
                </app-order-code-text-input>
                <app-checkbox-label id="chk_NotDesignateStart" #chk_NotDesignateStart [subid]="'chk_NotDesignateStart'"
                  label="指定なし" [(ngModel)]="kymw1506Model.notDesignateEnd" (change)="eventNotDesignateEnd_CLICKHandler()" [tabindex]="0"  [style.margin-top.px]="4">
                </app-checkbox-label>
              </div>
              <label class="list-input-title">使用終了配達企画回(翌週)</label>
              <div class="list-input-content">
                <input type="text" class="deliv-catalog" id="lbl_EndDelivCatalogId" #lbl_EndDelivCatalogId readonly/>
              </div>
              <label class="list-input-title">アイコンファイル(通常)</label>
              <div class="list-input-content">
                <input type="text" id="txti_ImageFileNormal" class="text-label-required-not-editable input-with-button" readonly="true"
                  [(ngModel)]="kymw1506Model.imageFileNameNormal" [tabindex]="0" plessInputTextSub [restrict]="'[ -￮]'"/>
                <button id="btn_ImageNormal" #btn_ImageNormal class="btn-secondary btn-select" (click)="eventImageNormal_ClickHandler()" [tabindex]="0">選択</button>
              </div>
              <label class="list-input-title">アイコンファイル(大)</label>
              <div class="list-input-content">
                <input type="text" id="txti_ImageFileBig" class="text-label-required-not-editable input-with-button" readonly="true"
                  [(ngModel)]="kymw1506Model.imageFileNameBig" [tabindex]="0" plessInputTextSub [restrict]="'[ -￮]'">
                <button id="btn_ImageBig" class="btn-secondary btn-select" (click)="eventImageBig_ClickHandler()" [tabindex]="0">選択</button>
              </div>
              <label class="list-input-title">アイコンファイル(モバイル)</label>
              <div class="list-input-content">
                <input type="text" id="txti_ImageFileMobile" class="text-label-required-not-editable input-with-button" readonly="true"
                  [(ngModel)]="kymw1506Model.imageFileNameMobile" [tabindex]="0" plessInputTextSub [restrict]="'[ -￮]'">
                <button id="btn_ImageMobile" class="btn-secondary btn-select" (click)="eventImageMobile_ClickHandler()" [tabindex]="0">選択</button>
              </div>
            </div>

            <div class="element-row">
              <div [style.width.px]="180" [style.height.px]="150"></div>
              <div class="element-column icon-file-wrapper">
                <label>通常</label>
                <div class="img-wrapper">
                  <img src={{kymw1506Model.imageFileUrlNormal}} *ngIf="kymw1506Model.imageFileUrlNormal !== ''">
                </div>
              </div>
              <div class="element-column icon-file-wrapper">
                <label>大</label>
                <div class="img-wrapper">
                  <img src={{kymw1506Model.imageFileUrlBig}} *ngIf="kymw1506Model.imageFileUrlBig !== ''">
                </div>
              </div>
              <div class="element-column icon-file-wrapper">
                <label>モバイル</label>
                <div class="img-wrapper">
                  <img src={{kymw1506Model.imageFileUrlMobile}} *ngIf="kymw1506Model.imageFileUrlMobile !== ''">
                </div>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">アイコン代替テキスト</label>
              <div class="list-input-content">
                <input type="text" [(ngModel)]="kymw1506Model.iconAlternativeText" [style.width.px]="380" [maxLength]="25"
                  plessInputTextSub [restrict]="'[ -￮]'" [fullOnly]="true">
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_add" class="btn-primary" (click)="eventAdd_CLICKHandler()"
            forcedEnabledMode="none" [tabindex]="0">追加</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
